import { Injectable } from '@angular/core';
import { SESSION_STORAGE_KEY } from '@core/configs';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  setSessionData(key: string, data: any): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving to sessionStorage', error);
    }
  }

  getSessionData<T = any>(key: string): T | null {
    try {
      const data = sessionStorage.getItem(key);
      return data ? JSON.parse(data) as T : null;
    } catch (error) {
      console.error('Error getting data from sessionStorage', error);
      return null;
    }
  }

  removeSessionData(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing data from sessionStorage', error);
    }
  }

  clearSessionStorage(): void {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('Error clearing sessionStorage', error);
    }
  }

  getAccessToken(): string {
    const accessToken = this.getSessionData(SESSION_STORAGE_KEY.accessToken);
    return accessToken || "";
  }

  getRefreshToken(): string {
    const refreshToken = this.getSessionData(SESSION_STORAGE_KEY.refreshToken);
    return refreshToken || "";
  }
}
